import React, {Fragment, useMemo} from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Heading from 'components/UI/Heading/Heading';
import Text from 'components/UI/Text/Text';
import LocationWrapper from './Location.style';
import Map, { MapDataProcessing } from 'components/Map/Map';
import { Element } from 'react-scroll';

const Location = ({
  city,
  country,
  location,
  phone,
  hours,
  hplink,
  titleStyle,
  locationMetaStyle,
  contentStyle,
  boldContentStyle,
  linkStyle,
  url,
  ...props
}) => {
  const { t } = useTranslation();
  const formattedHours = useMemo(() => 
    {
      if(!hours) return;
      return hours
            .replace('  ,', '\n')
            .replace('Sun,', 'Sun, ')
            .replace('Mon,', 'Mon, ')
            .replace('Tue,', 'Tue, ')
            .replace('Wed,', 'Wed, ')
            .replace('Thu,', 'Thu, ')
            .replace('Fri,', 'Fri, ')
            .replace('Sat,', 'Sat, ')}
  , [hours]);

  return (
    <Element name='location' className='location'>
      <LocationWrapper>
        <Heading as='h2' content={t('LOCATION')} {...titleStyle} />
        <Text content={`${city}, ${country}`} {...locationMetaStyle} />
        {navigator.userAgent !== 'ReactSnap' && (
          <Map key={`map-${location.id}`}>
            <MapDataProcessing
              location={location}
              multiple={false}
              isOpenedTooltip={true}
            />
          </Map>
        )}

        {!!phone && !!phone.length && (
          <Fragment>
            <Text
              content={t('PHONE')}
              {...contentStyle}
              {...boldContentStyle}
            />
            <Text content={phone} {...contentStyle} />
          </Fragment>
        )}

        {!!hours && !!hours.length && (
          <Fragment>
            <Text
              content={t('OFFICE_HOURS')}
              {...contentStyle}
              {...boldContentStyle}
            />
            <Text content={formattedHours} {...contentStyle} />
          </Fragment>
        )}

        {!!hplink && !!hplink.length && (
          <Fragment>
            <Text
              content={t('WEBSITE')}
              {...contentStyle}
              {...boldContentStyle}
            />
            <a href={hplink} target='_blank'>
              {hplink}
            </a>
          </Fragment>
        )}
      </LocationWrapper>
    </Element>
  );
};

Location.propTypes = {
  titleStyle: PropTypes.object,
  locationMetaStyle: PropTypes.object,
  contentStyle: PropTypes.object
};

Location.defaultProps = {
  titleStyle: {
    color: '#2C2C2C',
    fontSize: ['17px', '20px', '25px'],
    lineHeight: ['1.15', '1.2', '1.36'],
    mb: '4px'
  },
  locationMetaStyle: {
    fontSize: '13px',
    fontWeight: '400',
    color: '#909090',
    mb: ['14px', '20px', '27px']
  },
  contentStyle: {
    fontSize: '15px',
    fontWeight: '400',
    color: '#2C2C2C',
    lineHeight: '1.6',
    mb: ['14px', '20px', '27px']
  },
  boldContentStyle: {
    fontWeight: '700',
    mb: '0!important'
  },
  linkStyle: {
    fontSize: '15px',
    fontWeight: '700',
    color: '#008489'
  }
};

export default Location;
